<template>
  <div>
    <h6>{{ $t("electronic-archive.text") }}</h6>

    <LibraryItems
      rightPanelId="sidebar-new-datasource-electronic-archive"
      organizationScopedState="datasourceElectronicArchive"
      libraryScopedState="electronicArchive"
      :hideCategoryFilter="true"
      :hideSaveAs="true"
      @interceptForSetParent="interceptForSetParent"
    />
  </div>
</template>

<script>
import LibraryItems from "@cc/library-items";

export default {
  props: ["hide-library"],
  components: {
    LibraryItems,
  },
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
      entityName: undefined,
    };
  },

  computed: {
    isUpdating() {
      return this.$store.getters["datasourceElectronicArchive/isUpdating"];
    },
    //

    editedDatasource() {
      return this.$store.getters["datasourceElectronicArchive/editedDatasource"];
    },
  },
  mounted() {},
  methods: {
    cancel() {
      this.$store.dispatch("datasourceElectronicArchive/resetForm");
    },

    interceptForSetParent(payload) {
      payload.datasource = this.editedDatasource;
    },
  },
};
</script>
